export interface UpstreamHttpErrorOptions {
  status: number;
  upstream: string;
  operation?: string;
  message?: string;
  retryable?: boolean;
  cause?: unknown;
  details?: Record<string, unknown>;
}

export function isBadRequestStatus(status?: number | null): boolean {
  return status === 400;
}

export function isRetryableUpstreamStatus(status?: number | null): boolean {
  if (typeof status !== 'number') {
    return false;
  }

  return status === 429 || (status >= 500 && status <= 599);
}

export class UpstreamHttpError extends Error {
  public readonly status: number;
  public readonly upstream: string;
  public readonly operation: string | null;
  public readonly retryable: boolean;
  public readonly cause: unknown;
  public readonly details: Record<string, unknown> | null;

  constructor(options: UpstreamHttpErrorOptions) {
    const { status, upstream, operation, message, retryable, cause, details } =
      options;

    super(
      message ||
        `Upstream ${upstream}${operation ? ` ${operation}` : ''} returned HTTP ${status}`
    );

    Object.setPrototypeOf(this, new.target.prototype);
    this.name = 'UpstreamHttpError';
    this.status = status;
    this.upstream = upstream;
    this.operation = operation || null;
    this.retryable =
      retryable !== undefined ? retryable : isRetryableUpstreamStatus(status);
    this.cause = cause;
    this.details = details || null;
  }
}

export function isUpstreamHttpError(
  error: unknown
): error is UpstreamHttpError {
  return error instanceof UpstreamHttpError;
}
